import MyIndividualResourceModel from '../../generated/types/model/resource/MyIndividualResourceModel';

export default class MyIndividualResourceViewModel extends MyIndividualResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
